import React from "react";

import {
  ArrowLeft,
  Ship,
  MapPinned,
  ShieldCheck,
  Smartphone,
  Anchor,
  ArrowRight,
  CheckCircle2,
  Navigation,
} from "lucide-react";

import "../Styles/Ferry.css";

import { useNavigate }
from "react-router-dom";

const routes = [

  "WAKENAAM - PARIKA",
  "PARIKA - WAKENAAM",
  "PARIKA - LEGUAN",
  "LEGUAN - PARIKA",
  "PARIKA - SUPENAAM",
  "SUPENAAM - PARIKA",
  "GEORGETOWN - KUMAKA",
  "GEORGETOWN - PORT KAITUMA",
  "PARIKA - BARTICA",
  "BARTICA - PARIKA",
  "PARIKA - FORT ISLAND",
  "FORT ISLAND - PARIKA",
  "FORT ISLAND - BARTICA",
  "PORT KAITUMA - GEORGETOWN",
  "KUMAKA - GEORGETOWN",

];

const Ferry = () => {

  const navigate =
    useNavigate();

  return (

    <div className="modern-ferry-page">

      {/* HERO */}
      <section className="modern-ferry-hero">

        <div className="modern-ferry-overlay" />

        <div className="modern-ferry-content">

          <button
            className="modern-ferry-back-btn"
            onClick={() =>
              navigate("/services")
            }
          >

            <ArrowLeft size={18} />
            Back To Services

          </button>

          <div className="modern-ferry-badge">
            FERRYPASS SERVICES
          </div>

          <h1 className="modern-ferry-heading">
            Hassle-Free
            <span> Ferry Booking.</span>
          </h1>

          <p className="modern-ferry-text">
            RCS is the number one
            recommended Ferrypass
            booking agent on Wakenaam,
            offering fast, convenient and
            reliable ferry booking services
            anywhere in Guyana.
          </p>

        </div>

      </section>

      {/* HIGHLIGHTS */}
      <section className="modern-ferry-highlights">

        <div className="modern-ferry-highlight-card">

          <div className="modern-ferry-icon">
            <Ship size={34} />
          </div>

          <h3>
            Fast Booking
          </h3>

          <p>
            Quick and efficient ferry
            pass reservation services.
          </p>

        </div>

        <div className="modern-ferry-highlight-card">

          <div className="modern-ferry-icon">
            <Navigation size={34} />
          </div>

          <h3>
            Nationwide Routes
          </h3>

          <p>
            Ferry booking support
            across Guyana.
          </p>

        </div>

        <div className="modern-ferry-highlight-card">

          <div className="modern-ferry-icon">
            <ShieldCheck size={34} />
          </div>

          <h3>
            Trusted Assistance
          </h3>

          <p>
            Reliable support for
            accurate and secure bookings.
          </p>

        </div>

      </section>

      {/* ROUTES */}
      <section className="modern-ferry-routes">

        <div className="modern-ferry-routes-header">

          <div className="modern-ferry-routes-badge">
            AVAILABLE ROUTES
          </div>

          <h2>
            Ferry Routes We Support
          </h2>

          <p>
            RCS provides booking support
            for multiple Guyana ferry routes.
          </p>

        </div>

        <div className="modern-ferry-grid">

          {routes.map(
            (route, index) => (

            <div
              className="modern-route-card"
              key={index}
            >

              <div className="modern-route-icon">

                <MapPinned size={22} />

              </div>

              <span>
                {route}
              </span>

            </div>
          ))}

        </div>

      </section>

      {/* BOOKING CTA */}
      <section className="modern-booking-section">

        <div className="modern-booking-card">

          <div className="modern-booking-left">

            <div className="modern-booking-icon">
              <Anchor size={38} />
            </div>

            <h2>
              Want To Make
              Your Own Booking?
            </h2>

            <p>
              Head over to the official
              Ferrypass booking website,
              create your reservation and
              send us your booking number
              for payment confirmation.
            </p>

            <div className="modern-booking-alert">

              ENSURE YOU HAVE YOUR
              VEHICLE NUMBER,
              PHONE NUMBER AND
              VEHICLE TYPE READY
              BEFORE PROCEEDING.

            </div>

          </div>

          <div className="modern-booking-right">

            <a
              href="https://ferrypass.gy/search"
              target="_blank"
              rel="noopener noreferrer"
              className="modern-booking-btn"
            >

              <Smartphone size={18} />

              Make Booking

              <ArrowRight size={18} />

            </a>

          </div>

        </div>

      </section>

    </div>
  );
};

export default Ferry;